import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Table from '@material-ui/core/Table/Table';
import TableBody from '@material-ui/core/TableBody/TableBody';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TableRow from '@material-ui/core/TableRow/TableRow';
import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';
import getText from '../../../../nl-lib/i18n/language';
import { PageRangeField } from './PageRangeField';
import { RadioField } from './RadioField';
// const useStyles = makeStyles((theme: Theme) => {
//   createStyles({
//     paper: {
//       padding: theme.spacing(2),
//       textAlign: 'center',
//       color: theme.palette.text.secondary,
//     },
//   })
// });
export const cellRadioStyle = {
    paddingBottom: 2, paddingTop: 2,
    paddingLeft: 0, paddingRight: 0,
    border: "none",
    boxShadow: "none",
};
const lineBreak = 15;
export function LineBreak() {
    return (_jsx(TableRow, Object.assign({ style: { height: `${lineBreak}px` } }, { children: _jsx(TableCell, { style: cellRadioStyle }) })));
}
export const useLevelDialogStyles = makeStyles((theme) => createStyles({
    root: {
        flexGrow: 1,
        width: '100%',
    },
    scrollPaper: {
        alignItems: 'baseline' // default center
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    table: {
        minWidth: 650,
    },
    tr: {
        "padding-top": "0px !important",
        "padding-bottom": "0px !important",
    },
    td: cellRadioStyle,
}));
function OptionLevel0(props) {
    const { printOption, handleChange2, color } = props;
    // const [selectedValue, setSelectedValue] = React.useState('a');
    // const [localPrintOption, setLocalPrintOption] = useState(setDefaultPrintOption(undefined).printOption as IPrintOption);
    // useEffect(() => {
    //   setLocalPrintOption(printOption);
    // }, [printOption])
    // const theme = useTheme();
    const classes = useLevelDialogStyles();
    // const toggleDetailOption = (e) => {
    //   let level = optionLevel;
    //   if (optionLevel > 0) level = 0;
    //   else level = 1;
    //   props.levelCallback(level);
    // }
    // makeNPageIdStr
    // console.log(`OptionLevel1: level=${optionLevel}`);
    // const msg = optionLevel > 0 ? "고급 설정 닫기" : "고급 설정 열기";
    // const msi = MappingStorage.getInstance();
    // console.log(printOption);
    const help = printOption ? printOption.showTooltip : true;
    // const midbreak = 16;
    return (_jsxs(React.Fragment, { children: [_jsx(Table, Object.assign({ style: { borderCollapse: "collapse", border: "0" } }, { children: _jsxs(TableBody, { children: [_jsx(TableRow, Object.assign({ className: classes.tr }, { children: _jsx(TableCell, Object.assign({ colSpan: 2, style: cellRadioStyle }, { children: _jsxs(Typography, Object.assign({ variant: "subtitle1", component: "h5" }, { children: [" ", _jsxs("b", { children: [" ", getText("print_popup_select_paper"), " "] }), " "] })) })) })), _jsxs(TableRow, Object.assign({ className: classes.tr }, { children: [_jsx(TableCell, Object.assign({ colSpan: 1, style: cellRadioStyle }, { children: _jsx(RadioField, Object.assign({ showHelp: help, checked: printOption.hasToPutNcode ? printOption.hasToPutNcode : false, handleChange: handleChange2, color: color, name: "hasToPutNcode" }, { children: getText("print_popup_select_normal") })) })), _jsx(TableCell, Object.assign({ colSpan: 1, style: cellRadioStyle }, { children: _jsx(RadioField, Object.assign({ showHelp: help, checked: !printOption.hasToPutNcode, handleChange: handleChange2, color: color, name: "useNA4" }, { children: _jsxs("div", { children: [" ", getText("print_popup_select_ncode")] }) })) }))] })), _jsx(TableRow, { className: classes.tr }), _jsx(TableRow, Object.assign({ className: classes.tr }, { children: _jsx(TableCell, Object.assign({ colSpan: 1, style: cellRadioStyle, align: "right" }, { children: _jsx(RadioField, Object.assign({ showHelp: help, checked: printOption.downloadNcodedPdf, handleChange: handleChange2, color: color, name: "downloadNcodedPdf" }, { children: getText("print_popup_selectSub_savepdf") })) })) })), _jsx(TableRow, Object.assign({ style: { height: "24px" } }, { children: _jsx(TableCell, { colSpan: 2, style: cellRadioStyle }) }))] }) })), _jsx(Table, Object.assign({ style: { borderCollapse: "collapse", border: "0" } }, { children: _jsxs(TableBody, { children: [_jsx(TableRow, Object.assign({ className: classes.tr }, { children: _jsx(TableCell, Object.assign({ colSpan: 2, style: cellRadioStyle }, { children: _jsxs(Typography, Object.assign({ variant: "subtitle1", component: "h5" }, { children: [" ", _jsxs("b", { children: [" ", getText("print_popup_select_page_title"), " "] }), " "] })) })) })), _jsx(TableRow, Object.assign({ className: classes.tr }, { children: _jsx(TableCell, Object.assign({ colSpan: 2, style: cellRadioStyle }, { children: _jsxs(PageRangeField, Object.assign({ showHelp: help, range: printOption.targetPages, max: printOption.docNumPages, handleChange: handleChange2, color: color, name: "targetPages" }, { children: [console.log(getText("print_popup_select_page_selected"), printOption.docNumPages, printOption.targetPages.length.toString()), console.log(getText), getText("print_popup_select_page_selected").replace("%d", printOption.targetPages.length.toString())] })) })) }))] }) }))] }));
}
export default OptionLevel0;
//# sourceMappingURL=OptionLevel0.js.map